import {
  Component,
  ViewChild,
  Input,
  Output,
  ElementRef,
  EventEmitter, OnDestroy, AfterViewInit
} from '@angular/core';

// import * as $ from 'jquery';

export type TriggerType = 'click' | 'hover' | 'focus' | 'manual';

@Component({
  selector: 'ld-popover',
  templateUrl: './ld-popover.template.html'
})

export class LDPopoverComponent implements AfterViewInit, OnDestroy {
  // LD PUBLIC API

  // bootstrap 4 popover API
  @Input() placement: string = 'bottom'; // bottom, top, left, right
  @Input() width: string;
  @Input() height: string; // min-height

  @Input() trigger: TriggerType = 'click';
  @Input() container: string | boolean = 'body';

  @Input('popover-placeholder') placeholder: HTMLElement;

  @Output() show$ = new EventEmitter<void>();
  // TODO: change all properties of type EventEmitter to have subtype void and to have '$' at the end of name: look at show$
  @Output() shown: EventEmitter<any> = new EventEmitter<any>();
  @Output() hidden: EventEmitter<any> = new EventEmitter<any>();

  // INTERNAL API
  @ViewChild('trigger') private _trigger: ElementRef;
  @ViewChild('popover_content') private _popoverContent: ElementRef;

  // reference to an element that is used to trigger popover
  private _$trigger: any;
  // reference to bootstrap 4 popover instance
  private _popover: any;

  private _isMouseOverPopover: boolean = false;
  private _isPopoverVisible: boolean = false;
  private onDocumentMouseDownHandler: () => void; // defined in the constructor

  constructor() {
    // this is the only way that I found to keep scope of the LDPopover instance  and single reference to a function
    // this.onDocumentMouseDownHandler callback is passed to Jquery.on and .off functions
    this.onDocumentMouseDownHandler = (function () {
      if (this._isPopoverVisible && !this._isMouseOverPopover) {
        this.hide();
      }
    }).bind(this);
  }

  ngAfterViewInit() {
    this._$trigger = this.initPopoverTrigger(this.placeholder || this._trigger.nativeElement);

    this.initPopoverVisibilityTracker(this._$trigger);

    // keep reference to popover object to
    // access popover DOM element
    this._popover = this._$trigger.data('bs.popover');

    this._$trigger.on('show.bs.popover', () => {
      this.show$.emit();
    });

    this._$trigger.on('shown.bs.popover', () => {
      this.shown.emit(null);
    });

    this._$trigger.on('hidden.bs.popover', () => {
      this.hidden.emit(null);
    });

    this.callOnFirstPopoverShown(() => {
      this.removePopoverTitle(this._popover.tip);
      this.initMouseStateTracker(this._popover.tip);
      this.enableHideOnClickOutside();
    });
  }

  ngOnDestroy() {
    this._$trigger.popover('dispose');
    document.removeEventListener('mousedown', this.onDocumentMouseDownHandler);
    // $(document).off('mousedown', this.onDocumentMouseDownHandler);
  }


  // TODO: every popover now attaches listener to a document
  // it will be better to create one listener in a closure
  // that has references to all popovers
  enableHideOnClickOutside(): void {
    document.addEventListener('mousedown', this.onDocumentMouseDownHandler);
    // $(document).on('mousedown', this.onDocumentMouseDownHandler);
  }

  public hide(): void {
    this._$trigger.popover('hide');
    // this is the hack that prevents user from having
    // to double click trigger after manually calling
    // .popover('hide');
    this._popover._activeTrigger.click = false;
  }

  public show(): void {
    this._$trigger.popover('show');
    // this is the hack that prevents user from having
    // to double click trigger after manualy calling
    // .popover('show'); THIS IS NOT VERIFIED. IT'S ASSUMED FROM HIDING BEHAVIOR
    this._popover._activeTrigger.click = true;
  }

  private initPopoverTrigger(element): any {
    // return (<any>$(element)).popover({
    return element.popover({
      // supported props
      trigger: this.trigger,
      container: this.container,
      placement: this.placement,

      // static values
      html: true,
      content: this._popoverContent.nativeElement
    });
  }

  private removePopoverTitle(popoverElement: HTMLElement): void {
    popoverElement.querySelector('.popover-title').remove();
  }

  private callOnFirstPopoverShown(cb: () => void): void {
    this._$trigger.on('shown.bs.popover', () => {
      this._$trigger.off('shown.bs.popover');
      cb();
    });
  }

  private initMouseStateTracker(element: HTMLElement): void {
    element.addEventListener('mouseenter', () => this._isMouseOverPopover = true);
    element.addEventListener('mouseleave', () => this._isMouseOverPopover = false);
    // $(element)
    //   .on('mouseenter', (e) => {
    //     this._isMouseOverPopover = true;
    //   })
    //   .on('mouseleave', (e) => {
    //     this._isMouseOverPopover = false;
    //   });
  }

  private initPopoverVisibilityTracker($trigger: any): void {
    $trigger.on('show.bs.popover', () => {
      this._isPopoverVisible = true;
    }).on('hide.bs.popover', () => {
      this._isPopoverVisible = false;
    });
  }
}
